import { useMutation, useQuery } from 'react-query';
import generateApi from '../apis/generate';

const { generateResponseForNimbus } = generateApi;

export const useGenerateResponseForNimbus = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      return generateResponseForNimbus(payload);
    },
    onSuccess,
    onError,
  });
};
